<template>
  <div ref="SALARIE_LIST" :class="isCardView ? '' : 'section'">
    <section-header v-if="!hideTitle && !isCardView"
                    ref="SALARIE_LIST"
                    :ressource="ressource"
                    :isExtended="extended"
                    :dialog="dialog"
                    :canAdd="canAdd"
                    :addLabel="addLabel"
                    :fiche=fiche
                    :showSearch=showSearch
                    :addDisabled=addDisabled
                    :show-toggle="showToggle"
                    @search=onSearchTextUpdated
                    @extended=setExtended
                    @closeDialog=closeSection
                    @cardView=cardView
                    @callback=addItem>
    </section-header>
    <list-header v-if="isCardView"
                 :placeholder="placeholder"
                 :showSearch=showSearch
                 :isCardView="isCardView"
                 :show-toggle="showToggle"
                 @cardView=cardView
                 @search=onSearchTextUpdated>
    </list-header>
    <div v-if="extended">
      <v-row class="ma-0 filters-row" no-gutters>
        <v-col v-for="(item, index) in headers.filter(h => getConfig(h.value).isFilterable)" cols="auto" :key="index" class="pr-2">
          <data-table-filter :headerValue="item.value"
                             :label="item.text"
                             :columnConfig="getConfig(item.value)"
                             :currentFilters="getFilters(item.value)"
                             @apply="applyFilters">
          </data-table-filter>
        </v-col>
      </v-row>
      <div v-if="!isCardView">
        <v-data-table-server v-model="selected"
                             dense fixed-header
                                   :headers="headers"
                                   :items="items"
                                   :items-per-page="-1"
                                   :must-sort="true"
                                   :mobile-breakpoint="100"
                                   class="white"
                                   :hover=true
                                   no-data-text="Aucune donnée"
                                   :return-object=true
                                   :disable-pagination="true"
                                   :hide-default-footer="true"
                                   :show-select="showSelect"
                                   v-model:sort-by="sortBy"
                                   @update:sortBy="onSortUpdate"
                                   @click:row="selectItem">
          <template v-slot:[`item.nom`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('nom', item.nom, item ) }}</div>
          </template>
          <template v-slot:[`item.prenom`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('prenom', item.prenom, item ) }}</div>
          </template>
          <template v-slot:[`item.pseudo`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('pseudo', item.pseudo, item ) }}</div>
          </template>
          <template v-slot:[`item.emploiId`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('emploiId', item.emploiId, item ) }}</div>
          </template>
          <template v-slot:[`item.mailId`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('mailId', item.mailId, item ) }}</div>
          </template>
          <template v-slot:[`item.numeroId`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('numeroId', item.numeroId, item ) }}</div>
          </template>
          <template v-slot:[`item.adresseId`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('adresseId', item.adresseId, item ) }}</div>
          </template>
          <template v-slot:[`item.numeroSecu`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('numeroSecu', item.numeroSecu, item ) }}</div>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-row class="m-0">
              <div v-if="hasDocument(item)" class="col-2">
                <v-icon :disabled="actionProgress" @click.stop="displayDocument(item)" size="25" :color="getDocumentColor(item)">{{mdiDocument(item)}}</v-icon>
              </div>
              <div v-if="canDelete(item)" class="col-2">
                <v-icon :disabled="actionProgress" @click.stop="deleteItem(item)" size="25" color="border">fas fa-trash-can</v-icon>
              </div>
              <div v-if="canUpdate(item)" class="col-2">
                <v-icon :disabled="actionProgress" @click.stop="updateItem(item)" size="25" color="border">fas fa-pencil</v-icon>
              </div>
              <div v-if="hasAction(item)" class="col-2">
                <v-icon :disabled="actionProgress" @click.stop="execAction(item)" size="25" :color="getActionColor(item)">{{mdiAction(item)}}</v-icon>
              </div>
            </v-row>
          </template>
          <template v-for="(item, index) in headers" v-slot:[`header.${item.value}`]>
            <div :key="index" style="display: flex; align-items: center;">
              <div>{{ item.text }}</div>
              <v-icon v-if="getSortOrder(item.value)" class="sort-icon">
                {{ getSortOrder(item.value) === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down' }}
              </v-icon>
            </div>
          </template>
        </v-data-table-server>
        <v-row v-if="showCount" class="m-0">
          <v-col cols="11">
            <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="10" class="pagination-color"></v-pagination>
          </v-col>
          <v-col class="text-right align-content-center">
            {{ filteredCount }}/{{ totalCount }}
          </v-col>
        </v-row>
      </div>
      <div v-else class="card-list-container">
        <div v-for="(item, index) in items" :key="index" class="pb-2">
          <v-row @click="selectItemCard(item)" class="list-card ma-0">
            <v-col>
              <v-row class="ma-0">
                <div :class="item.avatar ? 'list-logo' : 'list-logo list-logo-initial'">
                  <img v-if="item.avatar" :src="item.avatar" width="100%"/>
                  <div v-else>{{ getInitials(item) }}</div>
                </div>
                <div style="padding-left: 16px; flex: 1; min-width: 0;">
                  <div class="card-title">
                    {{ getTitle(item.nom, item) }}
                  </div>
                  <div class="card-sub-title">
                    {{ item.pseudo }}
                  </div>
                </div>
              </v-row>
              <div class="seperator"/>
              <v-row class="ma-0">
                <div class="info-box">
                  <div class="info-header">N° Sécurité Sociale</div>
                  <div class="info-text">{{ getLabel('numeroSecu', item.numeroSecu, item ) }}
                    <v-icon v-if="item.numeroSecu" class="copy-text-icon" @click.stop="copyText(getLabel('numeroSecu', item.numeroSecu, item ), 0+index)">{{ copiedField === 0+index ? 'fas fa-check' : 'fas fa-copy' }}</v-icon>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-header">N° de téléphone</div>
                  <div class="info-text">{{ getLabel('numero', item.numero, item ) }}
                    <v-icon v-if="item.numero" class="copy-text-icon" @click.stop="copyText(getLabel('numero', item.numero, item ), 1+index)">{{ copiedField === 1+index ? 'fas fa-check' : 'fas fa-copy' }}</v-icon>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-header">Adresse email</div>
                  <div class="info-text">{{ getLabel('mail', item.mail, item ) }}
                    <v-icon v-if="item.mail" class="copy-text-icon" @click.stop="copyText(getLabel('mail', item.mail, item ), 2+index)">{{ copiedField === 2+index ? 'fas fa-check' : 'fas fa-copy' }}</v-icon>
                  </div>
                </div>
                <div class="info-box">
                  <div class="info-header">Métier</div>
                  <div class="info-text">{{ getLabel('emploiNom', item.emploiNom, item ) }}
                    <v-icon v-if="item.emploiNom" class="copy-text-icon" @click.stop="copyText(getLabel('emploiNom', item.emploiNom, item ), 3+index)">{{ copiedField === 3+index ? 'fas fa-check' : 'fas fa-copy' }}</v-icon>
                  </div>
                </div>
              </v-row>
            </v-col>
            <v-col cols="1" class="align-content-center align-items-center">
              <v-icon class="chevron-right">
                fas fa-chevron-right
              </v-icon>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
      <div v-if="!hasItems && isCardView" class="empty-list-container">
        <img src="@/assets/SVG/empty-list.svg" class="empty-list-logo"/>
        <div class="empty-list-label">{{ getNewLabel() }}</div>
      </div>
    <div class="pt-3" v-if="canAdd && isCardView">
      <v-btn class="base"
             :outlined="true"
             :loading="loading"
             :block="true"
             variant="flat"
             @click="addItem">
        {{ addLabel }}
      </v-btn>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <section-container :section="section"
                       :dialogOpen="dialogOpen"
                       :extended="true"
                       :fullscreen="fullscreen"
                       @closeDialog="closeDialog"
                       @saved="saved"
                       @updated="setUpdated">
    </section-container>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import Salarie from '@/extend/classes/Salarie';
  import { storeSession, storeSalarie } from '@/generated/stores';
  import { GenSection, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { Fiches } from '@/generated/classes/AppSchema';
  import Route from '@/extend/classes/Route';
  import DataTableFilter from '@/framework/base/components/DataTableFilter.vue';
  import { Alerts } from '@/framework/base/helpers/Alerts';
  import ListBase from '@/framework/base/components/ListBase';
  import SectionContainer from '@/framework/base/components/SectionContainer.vue';
  import Section from '@/framework/base/classes/Section';
  import ListData from '@/extend/classes/ListData';
  import HubServices from '@/generated/hub/HubServices';

  export default defineComponent({
    extends: ListBase,
    components: {
      SectionHeader,
      SectionContainer,
      DataTableFilter
    },
    props: {
      hideTitle: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      fiche: {
        type: String,
      },
    },

    mounted(): void {
      HubServices.connection.invoke('EnterSalarie', storeSession.httpToken);
      HubServices.connection.on('SalarieCreated', this.reloadTable);
      HubServices.connection.on('SalarieUpdated', this.reloadTable);
      HubServices.connection.on('SalarieDeleted', this.reloadTable);
    },

    beforeUnmount(): void {
      HubServices.connection.off('SalarieCreated', this.reloadTable);
      HubServices.connection.off('SalarieUpdated', this.reloadTable);
      HubServices.connection.off('SalarieDeleted', this.reloadTable);
    },

    data() {
    const selected: Salarie[] = [];
      return {
        selected,
        dialogOpen: false,
        isInitialised: false,
        actionProgress: false,
      }
    },

    computed: {
      ressource () { return RessourceGenSection(GenSection.SALARIE_LIST); },

      headers() {
        return [
          { text: "Nom", value: 'nom', cellClass: '', sortable: true },
          { text: "Prénom", value: 'prenom', cellClass: '', sortable: true },
          { text: "Pseudo", value: 'pseudo', cellClass: '', sortable: true },
          { text: "Métier", value: 'emploiId', cellClass: '', sortable: true },
          { text: "Adresse mail", value: 'mailId', cellClass: '', sortable: true },
          { text: "Numéro de téléphone", value: 'numeroId', cellClass: '', sortable: true },
          { text: "Adresse", value: 'adresseId', cellClass: '', sortable: true },
          { text: "N° sécu.", value: 'numeroSecu', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },

      items() : unknown[] {
        if (!this.isInitialised || (this.route && this.route.sectionObjId != this.lastRoute.sectionObjId)) {
          this.defaultFilter();
          this.setLastRoute();
          this.loadTable();
          this.isInitialised = true;
        }
        return this.listData.reccords;
      },

      showSearch() : boolean {
        return true;
      },

      hasItems() : boolean {
        return this.items.length > 0;
      },

      canAdd() : boolean {
        return true;
      },

      showCount() : boolean {
        return true;
      },

      addLabel() : string {
        return 'Ajouter';
      },

      addDisabled() : boolean {
        return false;
      },

      section(): Section {
        return new Section();
      }
    },

    methods: {
      loadTable (): void {
        if (this.loading) return;
        this.loading = true;
        Salarie.list(this.filter).then((res) => {
          this.listData = new ListData();
          this.listData = res;
          this.pageNumber = res.currentPage;
          this.loading = false;
          if (this.isAbstract && res.reccords.length == 0 && this.canAdd) {
            this.addItem();
          }
        });
        this.pageNumber = 1;
      },

      setLastRoute() {
        this.lastRoute = Route.fromJson(this.route);
      },

      canUpdate(salarie: Salarie) : boolean {
        return salarie.canUpdate;
      },

      canDelete(salarie: Salarie) : boolean {
        return salarie.canDelete;
      },

      mdiDocument (salarie: Salarie): string {
        return 'fas fa-file-pdf';
      },

      getDocumentColor (salarie: Salarie) : string {
        return '#F40F02';
      },

      hasDocument(salarie: Salarie) : boolean {
        return false;
      },

      displayDocument(salarie: Salarie) : void {
        //To implement
      },

      mdiAction (salarie: Salarie): string {
        return 'fas fa-arrow-pointer';
      },

      getActionColor  (salarie: Salarie): string {
        return '#1D6F42';
      },

      // eslint-disable-next-line
      hasAction(salarie: Salarie) : boolean {
        return false;
      },

      // eslint-disable-next-line
      execAction(salarie: Salarie) : void {
        //To implement
      },

      deleteItem(salarie: Salarie) {
        Alerts.alertDelete().then((res) => {
          if (res) {
            storeSalarie.deleteSalarie(salarie);;
          }
        });
      },

      updateItem(item: unknown) : void {
        const obj = item as Salarie;
        const route = new Route();
        route.fiche = Fiches.SALARIE;
        route.ficheObjId = obj.id;
        this.$emit('selectItem', route);
      },

      selectItem(event: any, row: any): void {
        const obj = row.item as Salarie;
        const route = new Route();
        route.fiche = Fiches.SALARIE;
        route.ficheObjId = obj.id;
        this.$emit('selectItem', route);
      },

      addItem(): void {
        const obj = storeSalarie.createNewSalarie();
        const route = new Route();
        route.fiche = Fiches.SALARIE;
        route.ficheObjId = obj.id;
        this.$emit('selectItem', route);
      },

      closeDialog(): void {
        this.dialogOpen = false;
      },

      closeSection(): void {
        this.$emit('closeDialog');
      },

      // eslint-disable-next-line
      saved(): void {
        // To implement
      },

      getNewLabel() : string {
        return ""
      }
    }
  })
</script>
